import { Utils } from '@genial/utils';

import { mountAccount } from '../../../../store/customer/normalize';
import { SelectedCustomer } from '../../../../store/customer/types';

import { Customer, CustomerTableItem, CustomerTableWidthCols, IconOption } from './models';

export const flatListMaxHeight = { desktop: '924px', tablet: '824px' };
export const rowHeight = { desktop: 80, tablet: 80 };

export const screenName = 'boleta-rapida';

export const tableParse = (item: Customer): CustomerTableItem => {
  return {
    name: item.name as string,
    custodyAccountNumber: mountAccount(item.pnpAccountNumber, item.pnpAccountDigit),
    suitabilityProfileName: item.suitabilityProfileName as string,
    cpfCnpjFormatted: Utils.Mask.CpfOrCnpj(item.cpfCnpjFormatted),
    registrationStatusName: item.registrationStatusName as string,
    registrationBlocked: item.registrationBlocked,
    availableBalance: Utils.Mask.Money(item.availableBalance),
    buttonSelectCustomer: 'Selecionar',
    professionalInvestor: item.professionalInvestor,
    qualifiedInvestor: item.qualifiedInvestor,
    accountId: item.accountId,
    customerId: item.customerId,
  };
};

export const tableHead: CustomerTableItem = {
  name: 'Nome',
  custodyAccountNumber: 'Conta de Custódia',
  suitabilityProfileName: 'Suitability',
  cpfCnpjFormatted: 'CPF/CNPJ',
  registrationStatusName: 'Cadastro',
  availableBalance: 'Saldo disponível',
  buttonSelectCustomer: '',
};

export const selectedKeysOrderBy = [
  'name',
  'custodyAccountNumber',
  'suitabilityName',
  'cpfCnpj',
  'statusId',
  'temporaryAvailableBalance',
];

const mappedFieldsOrderToFix = {
  cpfCnpjFormatted: 'cpfCnpj',
  suitabilityProfileName: 'suitabilityName',
  registrationStatusName: 'statusId',
  availableBalance: 'temporaryAvailableBalance',
};

export const fixOrderFields = (value: string): string => {
  // eslint-disable-next-line no-prototype-builtins
  if (mappedFieldsOrderToFix.hasOwnProperty(value)) {
    return mappedFieldsOrderToFix[value];
  }

  return value;
};

export const widthCols: CustomerTableWidthCols = {
  name: 15,
  custodyAccountNumber: 14,
  suitabilityProfileName: 14,
  cpfCnpjFormatted: 15,
  registrationStatusName: 14,
  availableBalance: 14,
  buttonSelectCustomer: 14,
};

export const invalidColumnsCalc =
  Object.entries(widthCols).reduce((acc, item) => acc + item[1], 0) !== 100;

export const customerCaptions = (obj: CustomerTableItem | SelectedCustomer): IconOption[] => {
  const result = [];

  if (obj.qualifiedInvestor) {
    result.push('QualifiedClient' as never);
  }

  if (obj.professionalInvestor) {
    result.push('ProfessionalInvestor' as never);
  }

  return result;
};

export const calculatePercentageWidth = (width: number) => {
  return Math.max(1, Math.min(width, 100));
};
